var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadEventEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "138px",
    height: "220px",
    viewBox: "0 0 138 220",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1D06F8B4-8171-473E-A560-3530F235E83B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-7.0%",
    width: "120.0%",
    height: "114.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Easy-booking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking-page---Error",
    transform: "translate(-535.000000, -70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sad-event-envelope",
    transform: "translate(544.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Illustrations-/-Envelope",
    filter: "url(#filter-1)",
    transform: "translate(0.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 120,
    height: 150,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, 40.000000)",
    fill: "#E4EAF0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 35,
    y: 0,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 70,
    y: 0,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 35,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 35,
    y: 35,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 70,
    y: 35,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 70,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 35,
    y: 70,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 70,
    y: 70,
    width: 30,
    height: 30,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 70,
    width: 30,
    height: 30,
    rx: 2
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    fill: "#E4EAF0",
    x: 0,
    y: 0,
    width: 120,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-5",
    fill: "#002F65",
    fillRule: "nonzero",
    opacity: 0.1,
    cx: 60,
    cy: 167,
    rx: 60,
    ry: 5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.6200397,15.8472222 C62.9394841,15.8472222 63.2056878,15.7407407 63.4186508,15.5277778 C63.6316138,15.3300265 63.7380952,15.0638228 63.7380952,14.7291667 L63.7380952,14.7291667 L63.7380952,14.4553571 C63.7380952,14.1359127 63.9206349,13.8240741 64.2857143,13.5198413 C64.4986772,13.3220899 64.9169974,13.0482804 65.5406746,12.6984127 C66.3621032,12.2268519 66.9477513,11.8541667 67.297619,11.5803571 C67.9060847,11.1087963 68.400463,10.5383598 68.780754,9.86904762 C69.1914683,9.10846561 69.3968254,8.24140212 69.3968254,7.26785714 C69.3968254,6.00529101 68.9937169,4.82638889 68.1875,3.73115079 C67.4725529,2.74239418 66.4837963,1.91335979 65.2212302,1.24404762 C64.0042989,0.62037037 62.7493386,0.308531746 61.4563492,0.308531746 L61.4563492,0.308531746 L61.5019841,0.354166667 C59.7222222,0.354166667 58.1934524,0.711640212 56.9156746,1.4265873 C55.7595899,2.08068783 54.6947751,3.08465608 53.7212302,4.43849206 C53.5539021,4.68187831 53.4930556,4.94047619 53.5386905,5.21428571 C53.5843254,5.4728836 53.7212302,5.69345238 53.9494048,5.87599206 L53.9494048,5.87599206 L55.8888889,7.35912698 C56.1018519,7.52645503 56.3528439,7.58730159 56.6418651,7.54166667 C56.8852513,7.49603175 57.1134259,7.35912698 57.3263889,7.13095238 C57.9500661,6.40079365 58.4976852,5.86078042 58.969246,5.5109127 C59.5472884,5.13062169 60.239418,4.94047619 61.0456349,4.94047619 C61.760582,4.94047619 62.4527116,5.14583333 63.1220238,5.55654762 C63.8065476,5.99768519 64.1488095,6.53769841 64.1488095,7.1765873 C64.1488095,7.63293651 63.9510582,8.03604497 63.5555556,8.3859127 C63.1904762,8.75099206 62.650463,9.11607143 61.9355159,9.48115079 L61.9355159,9.48115079 L61.844246,9.52678571 C60.7642196,10.0744048 59.9580026,10.6220238 59.4255952,11.1696429 C58.6498016,12.0062831 58.2619048,13.0406746 58.2619048,14.2728175 L58.2619048,14.2728175 L58.2619048,14.7291667 C58.2619048,15.0638228 58.3683862,15.3300265 58.5813492,15.5277778 C58.7943122,15.7407407 59.0605159,15.8472222 59.3799603,15.8472222 L59.3799603,15.8472222 L62.6200397,15.8472222 Z M61.0456349,23.3998016 C61.8974868,23.3998016 62.6124339,23.087963 63.1904762,22.4642857 C63.7989418,21.8101852 64.1031746,21.0724206 64.1031746,20.2509921 C64.1031746,19.4295635 63.7989418,18.6994048 63.1904762,18.0605159 C62.6124339,17.421627 61.8974868,17.1021825 61.0456349,17.1021825 C60.1937831,17.1021825 59.4712302,17.421627 58.8779762,18.0605159 C58.2847222,18.6994048 57.9880952,19.4295635 57.9880952,20.2509921 C57.9880952,21.057209 58.2847222,21.7949735 58.8779762,22.4642857 C59.4712302,23.087963 60.1937831,23.3998016 61.0456349,23.3998016 Z",
    id: "\\uF21D",
    fill: "#CAD2DD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "face",
    transform: "translate(26.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,39 C24,36 29,36 34,36 C34,36 44,36 44,39",
    id: "mouth",
    stroke: "#A4B3C7",
    strokeWidth: 4,
    opacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.000000, 17.000000)",
    fill: "#A4B3C7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5,-1.20259358e-12 C11.6421356,-1.20259358e-12 15,3.35786438 15,7.5 C15,9.67358121 14.0753737,11.6312044 12.5979939,13.0009965 L2.40200612,13.0009965 C0.924626347,11.6312044 0,9.67358121 0,7.5 C0,3.35786438 3.35786438,-1.20259358e-12 7.5,-1.20259358e-12 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5,-1.20259358e-12 C50.6421356,-1.20259358e-12 54,3.35786438 54,7.5 C54,9.67358121 53.0753737,11.6312044 51.5979939,13.0009965 L41.4020061,13.0009965 C39.9246263,11.6312044 39,9.67358121 39,7.5 C39,3.35786438 42.3578644,-1.20259358e-12 46.5,-1.20259358e-12 Z",
    id: "Combined-Shape"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A4B3C7",
    transform: "translate(56.000000, 6.500000) rotate(33.000000) translate(-56.000000, -6.500000) ",
    x: 49,
    y: 4,
    width: 14,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#A4B3C7",
    transform: "translate(8.000000, 6.500000) scale(-1, 1) rotate(33.000000) translate(-8.000000, -6.500000) ",
    x: 1,
    y: 4,
    width: 14,
    height: 5,
    rx: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEventEnvelope);
export default __webpack_public_path__ + "static/media/SadEventEnvelope.78bd73658adcf6de9fe3008bc1bfddb5.svg";
export { ForwardRef as ReactComponent };